import React, { Component } from 'react'
import { inject } from 'mobx-react'
import Input from '@components/Form/Input'
import Button from '@components/Button'
import { Formik, Form, Field } from 'formik'
import PropTypes from 'prop-types'

class LinkedContractsUpdateForm extends Component {
  render () {
    const { contractStore, title, linkedContract } = this.props
    const { contract } = contractStore

    return (
      <div>
        <h1>{title}</h1>
        <Formik
          initialValues={{
            linkReason: linkedContract.contractToContract.linkReason
          }}
          render={form => (
            <Form onSubmit={form.handleSubmit}>
              <div className='expert-form__section'>
                <Field
                  label='Link reason'
                  form={form}
                  name='linkReason'
                  component={Input}
                />
              </div>
              <div className='expert-form__section expert-form__section--buttons'>
                <Button
                  primary
                  submit
                  onClick={this.onSubmit}
                  disabled={form.isSubmitting}
                >
                  {this.props.okText}
                </Button>
                <Button
                  onClick={this.props.modalStore.close}
                  disabled={form.isSubmitting}
                >
                  {this.props.cancelText}
                </Button>
              </div>
            </Form>
          )}
          onSubmit={(values, action) => {
            this.props.contractStore
              .updateLinkedContracts(
                contract.id,
                linkedContract.id,
                values.linkReason
              )
              .then(this.props.modalStore.close)
          }}
        />
      </div>
    )
  }

  static propTypes = {
    contractStore: PropTypes.object,
    modalStore: PropTypes.object,
    linkedContract: PropTypes.object,
    title: PropTypes.string,
    okText: PropTypes.string,
    cancelText: PropTypes.string
  }

  static defaultProps = {
    hideButtons: true,
    showCloseIcon: false,
    shouldCloseOnOverlayClick: true
  }
}

export default inject('modalStore')(LinkedContractsUpdateForm)
